import React from 'react';

import { Col } from '@opendoor/atoms/box';

import { Loader } from './Loader';

export const FullPageHomeLoader: React.FC = () => (
  <Col className="min-h-screen w-full items-center justify-center bg-black">
    <Loader size="large" />
  </Col>
);
